class CuddleReviewSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-review-track]');
    this.slides = [...this.querySelectorAll('[data-review-slide]')];
    this.dots = [...this.querySelectorAll('[data-review-dot]')];

    if (!this.track || this.slides.length < 2) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.select(Number(dot.dataset.reviewDot)));
    });

    this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.updateActiveDot());
    this.resizeObserver.observe(this.track);
    this.updateActiveDot();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  select(index) {
    const slide = this.slides[index];
    if (!slide) return;

    const left = slide.offsetLeft - this.track.offsetLeft;
    this.track.scrollTo({ left, behavior: 'smooth' });
  }

  queueUpdate() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.updateActiveDot();
    });
  }

  updateActiveDot() {
    if (!this.track || !this.slides.length) return;

    const currentLeft = this.track.scrollLeft;
    let activeIndex = 0;
    let shortestDistance = Number.POSITIVE_INFINITY;

    this.slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - currentLeft);
      if (distance < shortestDistance) {
        shortestDistance = distance;
        activeIndex = index;
      }
    });

    this.dots.forEach((dot, index) => {
      if (index === activeIndex) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('cuddle-review-slider')) {
  customElements.define('cuddle-review-slider', CuddleReviewSlider);
}
